import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

interface CtaSectionProps {
  title?: string;
  description?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function CtaSection({
  title = "Commencez à organiser votre gestion immobilière dès aujourd'hui.",
  description = "Créez votre espace, ajoutez vos immeubles et suivez vos loyers en FCFA. La formule gratuite vous permet de démarrer sans engagement.",
  primaryLabel = "Commencer gratuitement",
  primaryTo = "/inscription",
  secondaryLabel = "Parler à un conseiller",
  secondaryTo = "/contact",
}: CtaSectionProps) {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-page">
        <Reveal variant="scale" className="relative overflow-hidden rounded-2xl bg-primary-950 px-6 py-12 md:px-12 md:py-16">
          <div className="float-slow pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-500/25" />
          <div className="float-slower pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-accent-500/20" />
          <div className="relative mx-auto max-w-2xl text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-semibold leading-tight text-background-50">
              {title}
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/85">{description}</p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to={primaryTo}
                className="group inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-base font-label font-medium text-secondary-950 hover:bg-accent-400 hover:-translate-y-0.5 transition-all cursor-pointer sm:w-auto"
              >
                {primaryLabel}
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
              </Link>
              <Link
                to={secondaryTo}
                className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-base font-label font-medium text-background-50 hover:bg-background-50/10 hover:-translate-y-0.5 transition-all cursor-pointer sm:w-auto"
              >
                {secondaryLabel}
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}